var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileHexagon = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.62A2.904 2.904 0 017 8.495c0-.83.293-1.537.88-2.12a2.904 2.904 0 012.125-.875c.83 0 1.537.293 2.12.88.583.587.875 1.295.875 2.125 0 .83-.293 1.537-.88 2.12a2.904 2.904 0 01-2.125.875c-.83 0-1.537-.293-2.12-.88zm3.188-1.057c.291-.292.437-.646.437-1.063 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0010 7c-.417 0-.77.146-1.063.438A1.447 1.447 0 008.5 8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437.417 0 .77-.146 1.063-.438zM10 18.25l-7-4.317v-7.85l7-4.333 7 4.325v7.862l-7 4.313zm0-1.75l3-1.854a6.557 6.557 0 00-1.458-.49A7.544 7.544 0 0010 14c-.528 0-1.042.052-1.542.156-.5.104-.986.268-1.458.49l3 1.854zm-4.48-2.77a8.815 8.815 0 012.153-.918 8.688 8.688 0 012.323-.312 8.73 8.73 0 014.483 1.23l1.021-.626V6.921L10 3.52l-5.5 3.4v6.183l1.02.625z"
  })));
};
export default SvgProfileHexagon;